// extracted by mini-css-extract-plugin
module.exports = {"majorContainer":"PopularBar_majorContainer__QtCJn","optionslist":"PopularBar_optionslist__jvHVR","options":"PopularBar_options__MYLGt"};